<div attr.name="CellOS_{{ item.name }}" class="tCol clickCol desktop" id="CellOS_{{ item.id }}">
    <span *ngIf="item.jwt">--</span>
    <span *ngIf="!item.jwt">{{ item[type] }}</span>
</div>
